import moment from 'moment';

export const getFormattedDate = (date?: Date, locale?: string) => (date && locale && moment(date).locale(locale).format(process.env.DATE_FORMAT || 'DD MMM YYYY')) || '';
